import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, sectionOf } from "@/lib/api";
import { MemberPhoto } from "./MemberPhoto";
import { SocialLinks } from "./SocialLinks";
import { BioButton } from "./BioButton";
import { Reveal, SectionLabel } from "./Reveal";

const FounderCard = ({ m, i }) => (
  <motion.article
    data-testid={`founder-card-${i}`}
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
    className="group relative overflow-hidden border border-white/10 bg-[#121216] min-h-[520px] md:min-h-[620px] flex flex-col justify-end p-6 md:p-10"
  >
    <MemberPhoto
      src={m.image_url}
      alt={m.name}
      testId={`founder-logo-card-${i}`}
      imgClass="grayscale group-hover:grayscale-0 transition-[filter] duration-700"
      glow="bg-[radial-gradient(circle_at_50%_30%,rgba(86,237,74,0.18),transparent_60%)]"
      logoClass="absolute left-1/2 top-[8%] -translate-x-1/2 w-[55%] max-w-[300px] object-contain group-hover:scale-110 group-hover:rotate-[-5deg] transition-transform duration-700"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
    <span className="absolute top-5 left-6 font-mono text-xs uppercase tracking-[0.25em] text-[#56ED4A]">Founder · {String(i + 1).padStart(2, "0")}</span>
    <div className="relative">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-300">{m.role}</p>
      <h3 data-testid={`founder-name-${i}`} className="font-display uppercase text-6xl md:text-8xl leading-[0.85] mt-2 break-words">{m.name}</h3>
      <div className="mt-6 flex flex-wrap gap-2"><BioButton m={m} testPrefix={`founder-${i}`} size="h-12" /><SocialLinks links={m.links} testPrefix={`founder-${i}`} size="w-12 h-12" /></div>
    </div>
  </motion.article>
);

export const Founders = () => {
  const [founders, setFounders] = useState([]);
  useEffect(() => {
    api.get("/members").then((r) => setFounders(Array.isArray(r.data) ? r.data.filter((m) => sectionOf(m) === "founder") : [])).catch(() => {});
  }, []);
  if (!founders.length) return null;
  return (
    <section id="founders" data-testid="founders-section" className="px-5 md:px-10 py-24 md:py-36">
      <Reveal>
        <SectionLabel index="02">The founders</SectionLabel>
        <h2 className="font-display uppercase text-6xl md:text-8xl lg:text-9xl leading-[0.85] mt-6">
          Created by <span className="chrome-text">{founders.map((f) => f.name).join(" and ")}</span>
        </h2>
      </Reveal>
      <div className={`mt-14 grid gap-3 ${founders.length > 1 ? "md:grid-cols-2" : ""}`}>
        {founders.map((m, i) => <FounderCard key={m.id} m={m} i={i} />)}
      </div>
    </section>
  );
};
